"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importStar(require("styled-components"));
var GlobalNavigation_styles_1 = require("../../GlobalNavigation.styles");
var withTheme_1 = __importDefault(require("../theme/withTheme"));
var NavigationHelperPendo = withTheme_1.default(styled_components_1.default.div(function (_a) {
    var isDiligentBrand = _a.isDiligentBrand, isTrainingOrg = _a.isTrainingOrg;
    return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      position: relative;\n      margin: 2px 2px 2px 0;\n\n      [data-sri-anchor='navigation-item.trigger'] {\n        ", "\n        ", "\n      }\n    "], ["\n      position: relative;\n      margin: 2px 2px 2px 0;\n\n      [data-sri-anchor='navigation-item.trigger'] {\n        ", "\n        ", "\n      }\n    "])), GlobalNavigation_styles_1.navigationTriggerStyles, isTrainingOrg ? GlobalNavigation_styles_1.navigationTrainingTheme : GlobalNavigation_styles_1.navigationTheme(isDiligentBrand));
}));
exports.default = NavigationHelperPendo;
var templateObject_1;
//# sourceMappingURL=HelperWithPendo.styles.js.map